/**
 * Stawki VAT dla lokali.
 *
 * Lokale mieszkalne 8%, uslugowe 23% (sovotele, biura typu Ovo Office).
 * Regula byla wczesniej powielona w kilku miejscach frontendu - tutaj jest jedna.
 * Ten sam warunek stosuje pipeline fakturujacy w Pythonie (invoice_pipeline.py,
 * process_mt940_cron.py), oparty na tym samym polu flat.type.
 */

export const RESIDENTIAL_VAT_RATE = 0.08;
export const COMMERCIAL_VAT_RATE = 0.23;

export const resolveVatRate = (flat) =>
  flat?.type === 'commercial' ? COMMERCIAL_VAT_RATE : RESIDENTIAL_VAT_RATE;

/** Netto z kwoty brutto, wg stawki lokalu. */
export const grossToNet = (gross, flat) => {
  const amount = Number(gross) || 0;
  if (!amount) return 0;
  return amount / (1 + resolveVatRate(flat));
};
